<template>
    <div class="dialog_section">
        <div class="content_box">
            <div class="search_box">
                <!--检索部分-->
                <el-form :inline="true" :model="navForm" class="demo-form-inline">
                    <el-form-item label="驾驶时间:">
                        <el-date-picker
                            class="forceWidth_250"
                            v-model="value2"
                            @change="pickerChange"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            size="small"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchTable" size="small" style="margin-left: 0.2rem">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <template v-if="Object.keys(navForm).length > 0">
                <div class="detail_title">基础信息</div>
                <ul class="detail_form">
                    <li>
                        <span>车牌号：</span>
                        <b>{{ navForm.plateNo }}</b>
                    </li>
                    <li>
                        <span>查询时段：</span>
                        <b v-if="navForm.tripTimeMin">{{ navForm.tripTimeMin.slice(0, 10) + ' 至 ' + navForm.tripTimeMax.slice(0, 10) }}</b>
                    </li>
                </ul>
            </template>
        </div>
        <div class="statistic_data" v-show="modeForm.totalMileage >= 0">
            <div class="content_box statistic_left">
                <div class="detail_title">
                    <b>统计数据</b>
                    <span v-if="modeForm.totalMileage < 100">该车辆驾驶里程过短，统计数据仅供参考</span>
                </div>
                <div class="score_box">
                    <p>驾驶评分</p>
                    <template v-if="modeForm.score > 0">
                        <div class="score">
                            <b>{{ modeForm.score }}</b>
                            <span>分</span>
                        </div>
                        <el-progress :show-text="false" :stroke-width="8" :percentage="modeForm.score" color="#05A9C5"></el-progress>
                    </template>
                    <template v-else>
                        <div class="null_score">
                            <!-- <span>Hi, 行程太少啦，暂无评分哦~</span> -->
                            <!-- <div><img src="../../public/images/msi/null_score.png"  ></div> -->
                            <img src="../../public/images/msi/null_score1.png" />
                        </div>
                    </template>
                </div>
                <div id="radar_chart"></div>
            </div>
            <div class="statistic_right">
                <ul class="flex">
                    <li>
                        <div class="item_top">
                            <div class="item_img"><img src="../../public/images/msi/licheng-3.png" /></div>
                            <div class="item_text">
                                <p>日均驾驶里程</p>
                                <div>
                                    <span>优于</span>
                                    <b>{{ modeForm.avgMileBetterPerc }}%</b>
                                    <span>车辆</span>
                                </div>
                            </div>
                        </div>
                        <div class="item_num">
                            <b>{{ modeForm.avgMile }}</b>
                            <span>km</span>
                        </div>
                    </li>
                    <li>
                        <div class="item_top">
                            <div class="item_img"><img src="../../public/images/msi/hangshishichang.png" /></div>
                            <div class="item_text">
                                <p>日均驾驶时长</p>
                                <div>
                                    <span>优于</span>
                                    <b>{{ modeForm.avgDurationBetterPerc }}%</b>
                                    <span>车辆</span>
                                </div>
                            </div>
                        </div>
                        <div class="item_num">
                            <b>{{ modeForm.avgDuration }}</b>
                            <span>h</span>
                        </div>
                    </li>
                    <li>
                        <div class="item_top">
                            <div class="item_img"><img src="../../public/images/msi/zaogaofeng.png" /></div>
                            <div class="item_text">
                                <p>早晚高峰日均驾驶时长</p>
                                <div>
                                    <span>优于</span>
                                    <b>{{ modeForm.avgRushDrivingHourBetterPerc }}%</b>
                                    <span>车辆</span>
                                </div>
                            </div>
                        </div>
                        <div class="item_num">
                            <b>{{ modeForm.avgRushDrivingHour }}</b>
                            <span>h</span>
                        </div>
                    </li>
                </ul>
                <ul class="flex" style="margin-top: 1.5%">
                    <li>
                        <div class="item_top">
                            <div class="item_img"><img src="../../public/images/msi/fatigue-early-warning_line.png" /></div>
                            <div class="item_text">
                                <p>日均疲劳驾驶时长</p>
                                <div>
                                    <span>优于</span>
                                    <b>{{ modeForm.avgFatiguedDrivingHourBetterPerc }}%</b>
                                    <span>车辆</span>
                                </div>
                            </div>
                        </div>
                        <div class="item_num">
                            <b>{{ modeForm.avgFatiguedDrivingHour }}</b>
                            <span>h</span>
                        </div>
                    </li>
                    <li>
                        <div class="item_top">
                            <div class="item_img"><img src="../../public/images/msi/cheliangzhongdian-chaosu.png" /></div>
                            <div class="item_text">
                                <p>百公里三急次数</p>
                                <div>
                                    <template v-if="modeForm.totalMileage >= 0">
                                        <span>优于</span>
                                        <b>{{ modeForm.alarm100KMBetterPerc }}%</b>
                                        <span>车辆</span>
                                    </template>
                                    <span v-else>暂无数据</span>
                                </div>
                            </div>
                        </div>
                        <div class="item_num">
                            <template v-if="modeForm.totalMileage >= 0">
                                <b>{{ Math.ceil(modeForm.alarm100KM / 1) }}</b>
                                <span>次</span>
                            </template>
                            <span v-else>暂无数据</span>
                        </div>
                    </li>
                    <li>
                        <div class="item_top">
                            <div class="item_img"><img src="../../public/images/msi/icon-jijiasu.png" /></div>
                            <div class="item_text">
                                <p>百公里超速次数</p>
                                <div>
                                    <template v-if="modeForm.totalMileage >= 0">
                                        <span>优于</span>
                                        <b>{{ modeForm.overSpeed100KMBetterPerc }}%</b>
                                        <span>车辆</span>
                                    </template>
                                    <span v-else>暂无数据</span>
                                </div>
                            </div>
                        </div>
                        <div class="item_num">
                            <template v-if="modeForm.totalMileage >= 0">
                                <b>{{ modeForm.overSpeed100KM }}</b>
                                <span>次</span>
                            </template>
                            <span v-else>暂无数据</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="!modeForm.score" v-loading="mileageLoading" style="margin-top: 2.1rem"></div>
        <div v-show="!modeForm.score && !mileageLoading" style="margin-top: 0.8rem">
            <el-empty description="暂无数据"></el-empty>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'BehaviouralDetail',
    props: {
        dialogVisible: Boolean,
        queryForm: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            value2: '',
            plateno: '',
            myChart: '',
            loading: false,
            percentage: 89,
            navForm: {
                //储存搜索框的检索条件信息
                startTime: '',
                endTime: ''
            },
            modeForm: {
                totalMileage: null
            },
            mileageLoading: true
        };
    },
    mounted() {
        this.setLastWeek();
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.navForm.companyId = this.userInfo.company;
        window.addEventListener('resize', () => {
            if (this.myChart) {
                setTimeout(() => {
                    this.myChart.dispose();
                    this.loadCharts();
                }, 500);
            }
        });
    },
    methods: {
        setLastWeek() {
            // 获取当前日期
            const today = new Date();

            // 计算一周前的日期（7天前）
            const lastWeek = new Date();
            lastWeek.setDate(today.getDate() - 7);

            // 格式化日期为YYYY-MM-DD格式
            function formatDate(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }

            this.value2 = [formatDate(lastWeek), formatDate(today)];
            this.pickerChange(this.value2);
        },
        pickerChange(val) {
            if (val && val.length > 1) {
                this.navForm.startTime = val[0] + ' 00:00:00';
                this.navForm.tripTimeMin = val[0] + ' 00:00:00';
                this.navForm.endTime = val[1] + ' 23:59:59';
                this.navForm.tripTimeMax = val[1] + ' 23:59:59';
            } else {
                this.navForm.startTime = null;
                this.navForm.tripTimeMin = null;
                this.navForm.endTime = null;
                this.navForm.tripTimeMax = null;
            }
        },
        //点击父组件的查看报警时调用的方法
        initData(navForm) {
            if (navForm.startTime && navForm.endTime) {
                this.navForm = JSON.parse(JSON.stringify(navForm));
            } else {
                this.selectMonth(3);
            }
            this.getTbodyData();
        },
        beforeClose(done) {
            this.navForm = {
                startTime: '',
                endTime: ''
            };
            this.$emit('beforeClose');
        },
        loadCharts() {
            var chartDom = document.getElementById('radar_chart');
            this.myChart = echarts.init(chartDom, null, { renderer: 'svg' });
            var modeForm = this.modeForm;
            var seriesData = [modeForm.avgMileBetterPerc, modeForm.avgDurationBetterPerc, modeForm.avgFatiguedDrivingHourBetterPerc, modeForm.alarm100KMBetterPerc, modeForm.overSpeed100KMBetterPerc];
            var option = {
                title: {
                    text: '驾驶行为因子评分统计',
                    textStyle: {
                        color: '#05A9C5',
                        fontSize: '0.24rem',
                        fontWeight: '300'
                    },
                    bottom: 30,
                    left: 'center'
                },
                radar: {
                    // shape: 'circle',
                    radius: '40%',
                    center: ['50%', '45%'],
                    axisName: {
                        show: true,
                        // width:40,
                        lineHeight: 12,
                        overflow: 'break',
                        fontSize: '0.14rem'
                    },
                    nameGap: 8,
                    indicator: [
                        { name: '日均驾驶里程因子', max: 100, color: '#051932' },
                        { name: '日均驾驶时长因子', max: 100, color: '#051932' },
                        { name: '日均疲劳驾驶因子', max: 100, color: '#051932' },
                        { name: '百公里三急因子', max: 100, color: '#051932' },
                        { name: '百公里超速因子', max: 100, color: '#051932' }
                    ],
                    splitArea: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(207, 229, 243, 1)'
                        }
                    }
                },
                tooltip: {
                    show: false
                },
                series: [
                    {
                        name: '驾驶评分因素',
                        type: 'radar',
                        lineStyle: {
                            color: '#CFE5F3'
                        },
                        symbol: 'none',
                        areaStyle: {
                            color: 'rgba(0, 192, 224, 0.2)'
                        },
                        lineStyle: {
                            color: 'rgba(0, 192, 224, 0.2)',
                            width: 3
                        },
                        data: [
                            {
                                value: seriesData
                            }
                        ]
                    }
                ]
            };
            this.myChart.setOption(option);
        },
        //选择日期
        selectDate(sign) {
            const start = new Date();
            const end = new Date();
            if (sign == 'today') {
                this.navForm.startTime = this.$$dateFormatting(start, 'yyyy-MM-dd');
                this.navForm.endTime = this.$$dateFormatting(end, 'yyyy-MM-dd');
            } else {
                var startTime = this.$$dateFormatting(new Date(start.getTime() - 3600 * 1000 * 24 * sign), 'yyyy-MM-dd');
                var endTime = this.$$dateFormatting(new Date(start.getTime() - 3600 * 1000 * 24 * 30), 'yyyy-MM-dd');
                this.navForm.startTime = startTime.slice(0, 7);
                this.navForm.endTime = endTime.slice(0, 7);
                // this.navForm.endTime=this.$$dateFormatting(end,'yyyy-MM-dd');
            }
        },
        //点击查询
        searchTable() {
            this.getTbodyData('search');
        },
        //获取tbody里的数据
        getTbodyData(sign) {
            this.mileageLoading = true;
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/drivingBehaviorAnalysisDetail', data: this.navForm }).then((res) => {
                this.mileageLoading = false;
                if (res.code == 200) {
                    for (const key in res.data) {
                        res.data[key] = String(res.data[key]).indexOf('.') > -1 ? Number(res.data[key].toFixed(2)) : res.data[key];
                    }
                    this.modeForm = res.data;

                    setTimeout(() => {
                        this.loadCharts();
                    }, 300);
                } else {
                    sign == 'search' && this.$message.error(res.message);
                }
            });
        }
    },
    watch: {
        queryForm: {
            handler(val) {
                if (!val) {
                    return;
                }

                this.navForm = this.queryForm.condition;
                // this.navForm.tripTimeMin = this.navForm.startTime;
                // this.navForm.tripTimeMax = this.navForm.endTime;
                this.navForm.subTenantId = this.navForm.curSubTenantId;
                this.navForm.plateNo = this.navForm.curPlatNo;
                this.navForm.deviceNumber = this.navForm.curDeviceNumber;
                this.initData(this.navForm);
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
.content_box {
    background: #fff;
    box-shadow: 0 2px 4px 0 hsla(0, 0%, 87.5%, 0.5);
    border-radius: 6px;
    border: 1px solid #ececec;
    padding: 0.2rem;
}
.dialog_section {
    overflow-y: auto;
    height: 580px;
}
.detail_form {
    display: flex;
    flex-wrap: wrap;
    li {
        min-width: 20%;
        font-size: 0.18rem;
        color: #828893;
        // padding: 0 0 0.3rem;
    }
}
.content {
    position: relative;
}
.detail_title {
    margin: 0 auto 0.2rem;
}
.statistic_left {
    .detail_title {
        padding-left: 0.2rem;
        span {
            color: #e4393c;
            font-size: 12px;
            margin-left: 0.1rem;
            width: 68%;
            line-height: 1.3;
        }
    }
}
.detail_form {
    border: 0;
    padding-bottom: 0.1rem;
    b {
        font-weight: 600;
        color: #686975;
    }
}
.statistic_data {
    margin-top: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.statistic_left {
    width: 27.9%;
    height: 6.02rem;
    padding: 0.2rem 0;
}
.statistic_right {
    width: 70.53%;
    height: 6.02rem;
    margin-left: 0.2rem;
}
.score_box {
    width: 92%;
    min-height: 1.3rem;
    border-radius: 0.06rem;
    border: 1px solid #b6e3ea;
    padding: 0.2rem 0.3rem;
    font-size: 0.18rem;
    color: #051932;
    margin: 0 auto;
}
.score {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    color: #05a9c5;
    margin-bottom: 0.12rem;
    b {
        font-size: 0.46rem;
        font-family: DINAlternate-Bold, DINAlternate;
        /* font-weight: bold; */
    }
}
.null_score {
    width: 100%;
    display: flex;
    align-items: center;
    /* padding-left:0.7rem; */
    color: #828893;
    font-size: 0.14rem;
    div {
        width: 1rem;
        margin-left: 0.2rem;
    }
}
.statistic_right {
    ul {
        width: 100%;
        li {
            width: 32%;
            height: 2.9rem;
            background: #ffffff;
            box-shadow: 0px 2px 14px 0px rgba(222, 222, 222, 0.5);
            border-radius: 0.06rem;
            padding-top: 0.4rem;
        }
    }
}
.item_top {
    display: flex;
    width: 100%;
    justify-content: center;
}
.item_img {
    width: 0.5rem;
    margin-right: 0.14rem;
}
.item_text {
    p {
        font-size: 0.24rem;
        margin-bottom: 0.1rem;
    }
    span {
        font-size: 0.2rem;
    }
    b {
        color: #05a9c5;
        font-size: 0.24rem;
    }
}
.item_num {
    margin-top: 0.6rem;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: baseline;
    font-size: 0.2rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: 600;
    color: #000000;
    b {
        font-size: 0.36rem;
    }
}
#radar_chart {
    width: 100%;
    height: 3.9rem;
    margin-top: 0.1rem;
}
</style>
